// extracted by mini-css-extract-plugin
export var gridWrapperStyle = "section_our_values-module--gridWrapperStyle--MugOx";